import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { memo, useMemo } from 'react';
import { createAccessStub } from 'console/stubs/others';
import { MapDashboard } from 'pages/dashboard.map/ui';
import { ZTHDashboard } from 'console/dashboards/zth';
import { WelcomeStub } from 'console/stubs/welcome-stub';
import { ErrorBoundary } from 'shared/components/error-boundary';
import { Box } from '@mui/material';
import { OfflineBanner } from 'shared/components/banners/offline';
import { FailureCards } from 'shared/components/banners/failure';
import { MasterSettingsBanner } from 'entities/settings-master/ui/banner';
import { DeviceContent } from 'app/content/device-content';
import { FileTransfers } from 'shared/components/banners/file-transfers';
import { SuggestionForLearningDialog } from 'console/ui-guide/suggestion';
import { Dashboard } from 'console/dashboards/z3k';
import { useTabContext } from 'console/navigation/context';
import { DashboardEvents } from 'console/dashboards/z3k/events';
import { useResizeDetector } from 'react-resize-detector';
import { UpdateIOExtensionFirmwareBanner } from 'shared/components/banners/update-io-extension/ui';
import { Z3kSettingsWriteBanner } from 'shared/components/banners/z3k-settings-write/z3k-settings-write-banner';
export const MainContent = memo(function MainContent(props) {
    const { ui, large } = props;
    const { device, legacy_device, show_wizard_banner, map_selected, zth_dashboard_selected, dashboard_selected, dashboard_events_selected, } = useTabContext();
    const show_offline_banner = useMemo(() => device && !device.online, [device]);
    // Проверяем есть ли доступ к устройству
    const stub = createAccessStub(device);
    const { height, ref } = useResizeDetector({
        handleWidth: false,
        refreshMode: 'throttle',
        refreshRate: 300,
    });
    if (dashboard_events_selected) {
        return _jsx(DashboardEvents, {});
    }
    if (dashboard_selected) {
        return _jsx(Dashboard, {});
    }
    if (map_selected) {
        return _jsx(MapDashboard, {});
    }
    if (zth_dashboard_selected) {
        return _jsx(ZTHDashboard, {});
    }
    if (device == null || legacy_device == null) {
        return _jsx(WelcomeStub, {});
    }
    if (stub) {
        return stub;
    }
    const config_write_status = device.config_write_status ?? false;
    return (_jsx(ErrorBoundary, { children: _jsxs(Box, { className: "tab-content iphone-safe-bottom-position", display: "flex", flexDirection: "column", overflow: "hidden", height: "100%", width: "100%", boxSizing: "border-box", bgcolor: "background.default", children: [_jsxs(Box, { "data-tooltip": "device-banners", ref: ref, children: [_jsx(SuggestionForLearningDialog, {}), show_offline_banner && _jsx(OfflineBanner, {}), _jsx(FailureCards, {}), _jsx(FileTransfers, { device_id: device.id }), _jsx(UpdateIOExtensionFirmwareBanner, { device_id: device.id, show_info: true }), show_wizard_banner && _jsx(MasterSettingsBanner, {}), config_write_status && (_jsx(Z3kSettingsWriteBanner, { config_write_status: config_write_status, device_id: device.id }))] }), _jsx(DeviceContent, { ui: ui, large: large, bannersHeight: height })] }) }));
});
